import Cookie from 'cookie-universal'
import { paths } from '@mc/paths'
import { forceSignoutAndRedirect } from '@mc/user-info'
import { signOut } from 'libs/client/api'
import { sprigLogout } from 'libs/sprig'
import { QUIZ_ONLY_ONCE_NEXT_PAGE_URL } from 'libs/utils/quizOnlyOnce'

const cookieClient = Cookie()

export const signOutHandler = (e: React.MouseEvent) => {
  e.preventDefault()
  signOut()
    .then(() => {
      sprigLogout()
      cookieClient.remove(QUIZ_ONLY_ONCE_NEXT_PAGE_URL, { path: '/' })
    })
    .catch(() => {
      // pass
    })
    .finally(() => {
      forceSignoutAndRedirect(paths.certificates)
    })
}
